import { RouteCategory } from '../types';

// Kids age range mapping
export function getAgeRange(range: string): { from: number; to: number } {
  switch (range) {
    case 'babies':
      return { from: 0, to: 1 };
    case '1to5':
      return { from: 1, to: 5 };
    case '6to12':
      return { from: 6, to: 12 };
    case 'teens':
      return { from: 13, to: 17 };
    default:
      return { from: 0, to: 17 };
  }
}

// Gender string mapping
export function getGenderCode(gender: string): string {
  switch (gender.toLowerCase()) {
    case 'women':
      return 'f';
    case 'men':
      return 'm';
    default:
      return '';
  }
}

// Navigation structure
export const mainNavItems = [
  {
    label: 'Women',
    path: '/women',
    children: [
      { label: 'Mainboard', path: '/women' },
      { label: 'New Faces', path: '/women/new-faces' },
    ],
  },
  {
    label: 'Men',
    path: '/men',
  },
  {
    label: 'Commercial',
    path: '/commercial',
    children: [
      { label: 'Female', path: '/commercial/women' },
      { label: 'Male', path: '/commercial/men' },
    ],
  },
  {
    label: 'Journal',
    path: '/blog',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Become a Model',
    path: '/become-a-model',
  },
];

// Category configurations for API calls
export function getCategoryConfig(
  category: string,
  subCategory?: string
): Omit<RouteCategory, 'path' | 'label' | 'menuItem' | 'menuSubItem'> {
  switch (category) {
    case 'women':
      return {
        typeNo: 1,
        albumNo: 0,
        gender: 'f',
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 0,
        customFieldValue: '',
        notCustomFieldId: 95,
        notCustomFieldValue: 'new faces',
      };
    case 'men':
      return {
        typeNo: 1,
        albumNo: 0,
        gender: 'm',
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 0,
        customFieldValue: '',
        notCustomFieldId: 95,
        notCustomFieldValue: 'new faces',
      };
    case 'newfaces':
      return {
        typeNo: 0,
        albumNo: 0,
        gender: 'f',
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 95,
        customFieldValue: 'new faces',
        notCustomFieldId: 0,
        notCustomFieldValue: '',
      };
    case 'development':
      return {
        typeNo: 0,
        albumNo: 0,
        gender: getGenderCode(subCategory || ''),
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 95,
        customFieldValue: 'new faces',
        notCustomFieldId: 0,
        notCustomFieldValue: '',
      };
    case 'commercial':
      return {
        typeNo: 8,
        albumNo: 0,
        gender: getGenderCode(subCategory || ''),
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 0,
        customFieldValue: '',
        notCustomFieldId: 95,
        notCustomFieldValue: 'new faces',
      };
    case 'kids': {
      const ageRange = getAgeRange(subCategory || 'babies');
      return {
        typeNo: 3,
        albumNo: 0,
        gender: '',
        ageFrom: ageRange.from,
        ageTo: ageRange.to,
        customFieldId: 0,
        customFieldValue: '',
        notCustomFieldId: 95,
        notCustomFieldValue: 'new faces',
      };
    }
    default:
      return {
        typeNo: 1,
        albumNo: 0,
        gender: 'f',
        ageFrom: 0,
        ageTo: 0,
        customFieldId: 0,
        customFieldValue: '',
        notCustomFieldId: 0,
        notCustomFieldValue: '',
      };
  }
}
